import { Box, Card, Grid, Typography } from '@mui/material';
import { agendaCardTitleColor, agendaCardTitleFontColor } from 'config';
import { useSelector } from 'react-redux';
import { AgendaListActionsBar } from './AgendaListActions';


function AgendaCardTitle() {
    const columnData = [
        { id: 'siralama', align: 'center', disablePadding: false, label: 'Sıra', xsValue: 1 },
        { id: 'decisionNo', align: 'center', disablePadding: false, label: 'Gündem No', xsValue: 1 },
        { id: 'subjectId', align: 'center', disablePadding: false, label: 'Konu', xsValue: 3 },
        { id: 'department', align: 'center', disablePadding: false, label: 'İlgi Birim/Kurum', xsValue: 3 },
        { id: 'pdate', align: 'center', disablePadding: false, label: 'Tarih', xsValue: 2 },
        { id: 'otherInfos', align: 'center', disablePadding: false, label: 'Diğer Bilgiler', xsValue: 2 },


        // { id: 'supp', align: 'center', disablePadding: false, label: 'Ek Gündem', xsValue: 1 },
        // { id: 'principle', align: 'center', disablePadding: false, label: 'İlke Kararı', xsValue: 1 },
        // { id: 'yaysisMeetingId', align: 'center', disablePadding: true, label: 'Yaysis Id', xsValue: 1 },
        // { id: 'saysMeetingId', align: 'center', disablePadding: true, label: 'Says Id', xsValue: 1 },
    ];

    const fontSettings = useSelector((state) => state.meeting.fontSettings);
    const { agendaFontSize } = fontSettings


    return (
        <Card
            elevation={0}
            sx={{
                margin: 0,
                padding: '15px',
                // minHeight: '100px',
                // maxHeight: '100px',
                width: '100%',
                boxShadow: 'none',

                backgroundColor: agendaCardTitleColor
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden', position: 'relative' }}>
                <Grid container sx={{ flex: 1, minWidth: 0 }}>
                    {columnData.map((item) => (
                        <Grid item xs={item.xsValue} key={item.id} sx={{ overflow: 'hidden', minWidth: 0 }}>
                            <Typography
                                color={agendaCardTitleFontColor}
                                sx={{
                                    fontSize: agendaFontSize,
                                    fontWeight: 'bold',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    pr: 0.5,
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
                <AgendaListActionsBar />
            </Box>
        </Card>
    );
}

export default AgendaCardTitle;
